import axios from "axios";
import { baseUrl } from "../BaseUrl";
const configToken = {
  headers: {
    Authorization: "Bearer " + `${localStorage.getItem("jwtToken")}`,
  },
};

export const convertCoin = (userData) => (dispatch) => {
  axios.post(baseUrl + "api/convert-coins", userData, configToken).then((res) =>
    dispatch({
      type: "CONVERT_COIN",
      payload: res,
    })
  );
};
